import { ACTION_TYPES as LocationPickerActions } from '@zocdoc/components/src/LocationPicker';
import { ActionTypes } from '../../actions/constants';

const initialState = {};

export default function pendingParametersReducer(state = initialState, action) {
    switch (action.type) {
        case ActionTypes.UPDATE_PENDING_PARAMETERS:
            return {
                ...state,
                ...action.payload,
            };

        case ActionTypes.UPDATE_PARAMETERS:
            return {};

        /**
         * GraphQL search uses location params in this priority: geoShape, coordinates, address, and ip.
         * Hence, higher priority props must be nulled out to ensure the most recently updated prop is used.
         */
        case LocationPickerActions.UPDATE_LOCATION:
            return {
                ...state,
                geoShape: null,
                latitude: action.location.lat,
                longitude: action.location.lng,
            };

        default:
            return state;
    }
}
